module.exports = __webpack_public_path__ + "static/img/noCoupons.6b73b9b3.png";